import { Box, Stack, styled, Typography } from "@mui/material";
import { CenteredBox } from "@/components/baseComponents/CenteredBox";
import { LandingCard } from "@/components/LandingCard";

export const StyledContainer = styled(CenteredBox)(() => ({
  flex: "1",
}));

export const StyledLandingCard = styled(LandingCard)(({ theme }) => ({
  maxWidth: "1024px",
  height: "614px",
  flexDirection: "row",

  [theme.breakpoints.down("desktop")]: {
    maxWidth: "520px",
    height: "auto",
  },

  [theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
  },
}));

export const StyledForm = styled(Stack)(({ theme }) => ({
  padding: "48px",
  rowGap: "20px",
  flex: "1",

  [theme.breakpoints.down("tablet")]: {
    padding: "20px",
  },
}));

export const StyledInputItem = styled(Stack)(() => ({
  rowGap: "12px",
}));

export const StyledInputLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle1,
}));

export const StyledRobot = styled(Box)(({ theme }) => ({
  width: "480px",
  height: "100%",

  [theme.breakpoints.down("desktop")]: {
    display: "none",
  },
}));
